import { useState } from "react"
import TeamMemberInterface from "../../interfaces/TeamMember.interface"
import Spinner from "../Spinner"
import { toggleAdmin } from "../../services/teamMember.services"
import { useAppDispatch, useAppSelector } from "../../store/store"
import { toast } from "react-toastify"
import { toggleTeamMemberAdmin } from "../../store/features/teamSlice"

const ToggleAdminButton: React.FC<{ teamMember: TeamMemberInterface }> = ({ teamMember }) => {
    const token = useAppSelector(state => state.token)
    const team = useAppSelector(state => state.team)
    const dispatch = useAppDispatch()

    const [requesting, setRequesting] = useState(false)

    const handleSubmit = () => {
        setRequesting(true)

        toggleAdmin({ token: token || "", teamId: team.id as string, teamMemberId: teamMember.id as string })
            .then((res) => {
                toast.success(res.data.message)
                dispatch(toggleTeamMemberAdmin(teamMember.id))
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
            .finally(() => {
                setRequesting(false)
            })
    }
    return (
        <button onClick={handleSubmit}>{requesting && <Spinner />} {teamMember.admin ? "Quitar Admin" : "Dar Admin"}</button>
    )
}

export default ToggleAdminButton